export default __webpack_public_path__ + "static/media/manuable_miles_guias_generadas.7f6cda80.png";